<template>
  <div class="relative my-4">
    <div class="absolute inset-0 flex items-center">
      <div class="w-full border-t border-slate-200/80 dark:border-slate-800"></div>
    </div>
    <div class="relative flex justify-center text-xs uppercase tracking-wider">
      <span class="px-3 bg-white/95 dark:bg-slate-900 text-slate-400 dark:text-slate-500 font-medium">
        {{ text }}
      </span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: "Or continue with",
  },
});
</script>
